import React from 'react';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Hero from './components/sections/Hero';
import Services from './components/sections/Services';
import Stats from './components/sections/Stats';
import Technologies from './components/sections/Technologies';
import Products from './components/sections/Products';
import BusinessFeatures from './components/sections/BusinessFeatures';
import SocialImpact from './components/sections/SocialImpact';
import GlobalPresence from './components/sections/GlobalPresence';
import Testimonials from './components/sections/Testimonials';
import Process from './components/sections/Process';
import About from './components/sections/About';
import Team from './components/sections/Team';
import Contact from './components/sections/Contact';
import Faq from './components/sections/Faq';
import ScrollToTop from './components/ui/ScrollToTop';

import './assets/styles/index.css';
import './assets/styles/dark-theme.css';

function App() {
  return (
    <div className="font-sans dark-grid-bg text-gray-100">
      <Header />
      
      <main>
        <Hero />
        <Products />
        <Services />
        <BusinessFeatures />
        <SocialImpact />
        <GlobalPresence />
        <Testimonials />
        <Stats />
        <Technologies />
        <Process />
        <About />
        <Team />
        <Contact />
        <Faq />
      </main>
      
      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default App;